import { render, staticRenderFns } from "./InformeFlow.vue?vue&type=template&id=6ec56a62&scoped=true&"
import script from "./InformeFlow.vue?vue&type=script&lang=js&"
export * from "./InformeFlow.vue?vue&type=script&lang=js&"
import style0 from "./InformeFlow.vue?vue&type=style&index=0&id=6ec56a62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec56a62",
  null
  
)

export default component.exports